import { render } from "./ListReflectionSubKomunitasView.vue?vue&type=template&id=999661b4"
import script from "./ListReflectionSubKomunitasView.vue?vue&type=script&lang=js"
export * from "./ListReflectionSubKomunitasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__